import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_GATEWAY_URL } from "constants/constants";

export const updatePassword = async (payload) => {
  const { product_id, tenant_id, ...body } = payload;
  const endpoint = `${REACT_APP_GATEWAY_URL}/api/v1/unified/reset-password`;

  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      "product-id": product_id,
      "tenant-id": tenant_id,
      platform: "web",
    },
    body,
  };

  return await fetchJSON(endpoint, options);
};

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: updatePassword,
  });
};
